import {MoovementApiClient} from "src/app/infrastructure/moovement-api/web-api/moovement.api-client";
import {Observable} from "rxjs";
import {Injectable} from "@angular/core";
import {LoRaGateway, LoRaGatewayStatus} from "src/app/infrastructure/moovement-api/models/asset";

@Injectable({
  providedIn: 'root'
})
export class GatewayApiClient extends MoovementApiClient {



  create(gateway: LoRaGateway): Observable<LoRaGateway> {
    return this.httpClient.put<LoRaGateway>(`${this.baseUrl}/api/gateway`, gateway);
  }

  get(id: string): Observable<LoRaGateway> {
    return this.httpClient.get<LoRaGateway>(`${this.baseUrl}/api/gateway/${id}`);
  }

  merge(gateway: LoRaGateway): Observable<LoRaGateway> {
    return this.httpClient.post<LoRaGateway>(`${this.baseUrl}/api/gateway`, gateway);
  }

  unassign(gateway: LoRaGateway): Observable<LoRaGateway> {
    gateway.farmId = '00000000-0000-0000-0000-000000000000';
    return this.httpClient.post<LoRaGateway>(`${this.baseUrl}/api/gateway`, gateway);
  }

  getStatus(eui: string): Observable<LoRaGatewayStatus> {
    return this.httpClient.get<LoRaGatewayStatus>(`${this.baseUrl}/api/gateway/${eui}/status`);
  }
}
